module.exports = __webpack_public_path__ + "static/customer-42a03adf78167098498f973d13695328.png";